const headers = {
  name: "Purchases Returns",
  navigate: {
    path: [
      {
        name: "Purchase Returns",
        path: "/app/purchases/returns",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
